import { FormDivider } from './Divider';
import AdvancedReference from './Reference';
import Formula from './Formula';
import FormText from './Text';
import Unknown from './Unknown';
import LinkedFieldDisplay from "./LinkedFieldDisplay";
import GoogleField from "./GoogleField";
import Embed from "./Embed";
import {FormSpacer} from "./Spacer";
import FormGPT from "./GPT";

export const FormFields = {
  custom_divider: FormDivider,
  custom_text: FormText,
  custom_reference: AdvancedReference,
  custom_formula:  Formula,
  custom_linked_field_display: LinkedFieldDisplay,
  custom_google_file: GoogleField,
  custom_embed: Embed,
  custom_spacer: FormSpacer,
  custom_gpt: FormGPT,
  unknown: Unknown,
};

export default FormFields;
